import styled from 'styled-components';

export const CartItemList = styled.ul`
    margin-bottom: 80px;
    li {
        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }
`;
